import React, { useState, useEffect } from 'react';
import { customerAPI } from '../services/api';

const Customers = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAdd, setShowAdd] = useState(false);
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState(null);
  const [detail, setDetail] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({
    company_name:'', contact_person:'',
    email:'', phone:'', alternate_phone:'',
    gst_number:'', billing_address:'',
    city:'', state:'', pincode:'', notes:'',
  });

  useEffect(() => {
    loadCustomers();
  }, []);

  const loadCustomers = async () => {
    setLoading(true);
    try {
      const params = {};
      if (search) params.search = search;
      const res = await customerAPI.getAll(params);
      setCustomers(res.data.data);
    } catch (err) {
      console.error('Failed:', err);
    } finally {
      setLoading(false);
    }
  };

  const loadDetail = async (id) => {
    try {
      const res = await customerAPI.getOne(id);
      setDetail(res.data.data);
    } catch (err) {
      console.error('Failed:', err);
    }
  };

  const handleAdd = async () => {
    if (!form.company_name || !form.phone) {
      setError(
        'Company name and phone are required');
      return;
    }
    setSaving(true);
    setError('');
    try {
      await customerAPI.add(form);
      setForm({
        company_name:'', contact_person:'',
        email:'', phone:'', alternate_phone:'',
        gst_number:'', billing_address:'',
        city:'', state:'', pincode:'', notes:'',
      });
      setShowAdd(false);
      await loadCustomers();
    } catch (err) {
      setError(
        err.response?.data?.message
        || 'Failed to add customer');
    } finally {
      setSaving(false);
    }
  };

  const inputStyle = {
    width:'100%',
    background:'var(--surface2)',
    border:'1px solid var(--border2)',
    color:'var(--text)',
    padding:'10px 14px',
    borderRadius:'8px',
    fontSize:'13.5px',
    outline:'none',
  };

  const labelStyle = {
    display:'block',
    fontSize:'11px',
    fontFamily:'DM Mono,monospace',
    color:'var(--text3)',
    letterSpacing:'1px',
    textTransform:'uppercase',
    marginBottom:'6px',
  };

  return (
    <div style={{ padding:'24px' }}>
      {/* Header */}
      <div style={{
        display:'flex',
        justifyContent:'space-between',
        alignItems:'center',
        marginBottom:'24px',
      }}>
        <div>
          <h1 style={{
            fontFamily:'Syne,sans-serif',
            fontSize:'22px', fontWeight:'800',
          }}>
            Customers
          </h1>
          <p style={{
            color:'var(--text3)',
            fontSize:'13px', marginTop:'4px',
          }}>
            Manage your customer directory
          </p>
        </div>
        <button
          onClick={() => setShowAdd(!showAdd)}
          style={{
            background:'var(--accent)',
            color:'var(--bg)',
            border:'none',
            padding:'10px 20px',
            borderRadius:'8px',
            fontSize:'13px',
            fontWeight:'600',
            cursor:'pointer',
          }}
        >
          + Add Customer
        </button>
      </div>

      {/* Add Customer Form */}
      {showAdd && (
        <div style={{
          background:'var(--surface)',
          border:'1px solid var(--border)',
          borderRadius:'12px',
          padding:'24px',
          marginBottom:'20px',
        }}>
          <div style={{
            fontFamily:'Syne,sans-serif',
            fontSize:'15px', fontWeight:'700',
            marginBottom:'20px',
          }}>
            Add New Customer
          </div>
          <div style={{
            display:'grid',
            gridTemplateColumns:'1fr 1fr',
            gap:'16px',
          }}>
            <div>
              <label style={labelStyle}>
                Company Name *
              </label>
              <input style={inputStyle}
                placeholder="Company or person name"
                value={form.company_name}
                onChange={e => setForm({
                  ...form,
                  company_name:e.target.value
                })}
              />
            </div>
            <div>
              <label style={labelStyle}>
                Contact Person
              </label>
              <input style={inputStyle}
                placeholder="Contact person name"
                value={form.contact_person}
                onChange={e => setForm({
                  ...form,
                  contact_person:e.target.value
                })}
              />
            </div>
            <div>
              <label style={labelStyle}>
                Phone *
              </label>
              <input style={inputStyle}
                placeholder="Primary phone"
                value={form.phone}
                onChange={e => setForm({
                  ...form, phone:e.target.value
                })}
              />
            </div>
            <div>
              <label style={labelStyle}>
                Alternate Phone
              </label>
              <input style={inputStyle}
                placeholder="Alternate phone"
                value={form.alternate_phone}
                onChange={e => setForm({
                  ...form,
                  alternate_phone:e.target.value
                })}
              />
            </div>
            <div>
              <label style={labelStyle}>
                Email
              </label>
              <input style={inputStyle}
                placeholder="Email address"
                value={form.email}
                onChange={e => setForm({
                  ...form, email:e.target.value
                })}
              />
            </div>
            <div>
              <label style={labelStyle}>
                GST Number
              </label>
              <input style={inputStyle}
                placeholder="GST (optional)"
                value={form.gst_number}
                onChange={e => setForm({
                  ...form,
                  gst_number:e.target.value
                })}
              />
            </div>
            <div>
              <label style={labelStyle}>
                City
              </label>
              <input style={inputStyle}
                placeholder="City"
                value={form.city}
                onChange={e => setForm({
                  ...form, city:e.target.value
                })}
              />
            </div>
            <div>
              <label style={labelStyle}>
                State
              </label>
              <input style={inputStyle}
                placeholder="State"
                value={form.state}
                onChange={e => setForm({
                  ...form, state:e.target.value
                })}
              />
            </div>
            <div>
              <label style={labelStyle}>
                Pincode
              </label>
              <input style={inputStyle}
                placeholder="Pincode"
                value={form.pincode}
                onChange={e => setForm({
                  ...form,
                  pincode:e.target.value
                })}
              />
            </div>
            <div>
              <label style={labelStyle}>
                Notes
              </label>
              <input style={inputStyle}
                placeholder="Any notes"
                value={form.notes}
                onChange={e => setForm({
                  ...form, notes:e.target.value
                })}
              />
            </div>
            <div style={{
              gridColumn:'1 / -1',
            }}>
              <label style={labelStyle}>
                Billing Address
              </label>
              <textarea
                style={{
                  ...inputStyle,
                  minHeight:'70px',
                  resize:'vertical',
                }}
                placeholder="Full billing address"
                value={form.billing_address}
                onChange={e => setForm({
                  ...form,
                  billing_address:e.target.value
                })}
              />
            </div>
          </div>

          {error && (
            <div style={{
              background:
                'rgba(255,77,109,0.1)',
              border:
                '1px solid rgba(255,77,109,0.3)',
              color:'var(--red)',
              padding:'10px 14px',
              borderRadius:'8px',
              fontSize:'13px',
              marginTop:'16px',
            }}>
              {error}
            </div>
          )}

          <div style={{
            display:'flex', gap:'10px',
            marginTop:'20px',
          }}>
            <button onClick={handleAdd}
              disabled={saving}
              style={{
                background:'var(--accent)',
                color:'var(--bg)',
                border:'none',
                padding:'10px 24px',
                borderRadius:'8px',
                fontSize:'13px',
                fontWeight:'600',
                cursor: saving
                  ? 'not-allowed' : 'pointer',
              }}
            >
              {saving
                ? 'Saving...' : 'Save Customer'}
            </button>
            <button
              onClick={() => {
                setShowAdd(false);
                setError('');
              }}
              style={{
                background:'transparent',
                color:'var(--text2)',
                border:
                  '1px solid var(--border2)',
                padding:'10px 24px',
                borderRadius:'8px',
                fontSize:'13px',
                cursor:'pointer',
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* Search */}
      <div style={{
        display:'flex', gap:'10px',
        marginBottom:'16px',
      }}>
        <div style={{
          display:'flex',
          alignItems:'center',
          background:'var(--surface2)',
          border:'1px solid var(--border2)',
          borderRadius:'8px',
          padding:'0 12px',
          gap:'8px', flex:1,
          maxWidth:'300px',
        }}>
          <span style={{
            color:'var(--text3)',
          }}>⊞</span>
          <input
            placeholder="Search customers..."
            value={search}
            onChange={e =>
              setSearch(e.target.value)}
            onKeyPress={e =>
              e.key === 'Enter' &&
              loadCustomers()}
            style={{
              background:'none',
              border:'none', outline:'none',
              color:'var(--text)',
              fontSize:'13px',
              padding:'9px 0', flex:1,
            }}
          />
        </div>
        <button onClick={loadCustomers}
          style={{
            background:'var(--surface2)',
            border:'1px solid var(--border2)',
            color:'var(--text2)',
            padding:'8px 16px',
            borderRadius:'8px',
            fontSize:'13px',
            cursor:'pointer',
          }}
        >
          Search
        </button>
      </div>

      {/* Main Layout */}
      <div style={{
        display:'grid',
        gridTemplateColumns:
          selected ? '1fr 360px' : '1fr',
        gap:'16px',
      }}>
        {/* Customers Table */}
        <div style={{
          background:'var(--surface)',
          border:'1px solid var(--border)',
          borderRadius:'12px',
          overflow:'hidden',
        }}>
          {loading ? (
            <div style={{
              padding:'40px',
              textAlign:'center',
              color:'var(--text3)',
              fontFamily:'DM Mono,monospace',
            }}>
              Loading customers...
            </div>
          ) : customers.length === 0 ? (
            <div style={{
              padding:'60px',
              textAlign:'center',
              color:'var(--text3)',
            }}>
              <div style={{
                fontSize:'40px',
                marginBottom:'12px',
              }}>◫</div>
              <div style={{
                fontSize:'14px',
                color:'var(--text2)',
                marginBottom:'6px',
              }}>
                No customers yet
              </div>
              <div style={{ fontSize:'12px' }}>
                Click "+ Add Customer"
                to add your first customer
              </div>
            </div>
          ) : (
            <table style={{
              width:'100%',
              borderCollapse:'collapse',
            }}>
              <thead>
                <tr>
                  {[
                    'Company','Contact',
                    'Phone','City',
                    'Total Orders',
                    'Active','Actions'
                  ].map(h => (
                    <th key={h} style={{
                      padding:'10px 16px',
                      textAlign:'left',
                      fontSize:'10px',
                      fontFamily:
                        'DM Mono,monospace',
                      color:'var(--text3)',
                      letterSpacing:'1.5px',
                      textTransform:'uppercase',
                      borderBottom:
                        '1px solid var(--border)',
                      background:
                        'var(--surface2)',
                    }}>
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {customers.map(c => (
                  <tr key={c.id}
                    onClick={() => {
                      setSelected(c);
                      loadDetail(c.id);
                    }}
                    style={{
                      borderBottom:
                        '1px solid var(--border)',
                      cursor:'pointer',
                      background:
                        selected?.id === c.id
                          ? 'rgba(0,212,255,0.05)'
                          : 'transparent',
                    }}
                  >
                    <td style={{
                      padding:'12px 16px',
                    }}>
                      <div style={{
                        fontWeight:'600',
                        fontSize:'13px',
                      }}>
                        {c.company_name}
                      </div>
                      {c.gst_number && (
                        <div style={{
                          fontSize:'10px',
                          color:'var(--text3)',
                          fontFamily:
                            'DM Mono,monospace',
                          marginTop:'2px',
                        }}>
                          GST: {c.gst_number}
                        </div>
                      )}
                    </td>
                    <td style={{
                      padding:'12px 16px',
                      fontSize:'13px',
                      color:'var(--text2)',
                    }}>
                      {c.contact_person || '—'}
                    </td>
                    <td style={{
                      padding:'12px 16px',
                      fontSize:'12px',
                      fontFamily:
                        'DM Mono,monospace',
                      color:'var(--text2)',
                    }}>
                      {c.phone}
                    </td>
                    <td style={{
                      padding:'12px 16px',
                      fontSize:'13px',
                      color:'var(--text2)',
                    }}>
                      {c.city || '—'}
                    </td>
                    <td style={{
                      padding:'12px 16px',
                      textAlign:'center',
                      fontFamily:
                        'DM Mono,monospace',
                      color:'var(--accent)',
                    }}>
                      {c.total_tickets || 0}
                    </td>
                    <td style={{
                      padding:'12px 16px',
                      textAlign:'center',
                      fontFamily:
                        'DM Mono,monospace',
                      color:'var(--yellow)',
                    }}>
                      {c.active_tickets || 0}
                    </td>
                    <td style={{
                      padding:'12px 16px',
                    }}>
                      <button
                        onClick={e => {
                          e.stopPropagation();
                          setSelected(c);
                          loadDetail(c.id);
                        }}
                        style={{
                          background:
                            'rgba(0,212,255,0.1)',
                          color:'var(--accent)',
                          border:
                            '1px solid rgba(0,212,255,0.2)',
                          padding:'4px 12px',
                          borderRadius:'6px',
                          fontSize:'12px',
                          cursor:'pointer',
                        }}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {/* Detail Panel */}
        {selected && detail && (
          <div style={{
            background:'var(--surface)',
            border:'1px solid var(--border)',
            borderRadius:'12px',
            overflow:'hidden',
            height:'fit-content',
          }}>
            <div style={{
              padding:'16px 20px',
              borderBottom:
                '1px solid var(--border)',
              display:'flex',
              justifyContent:'space-between',
              alignItems:'center',
            }}>
              <div style={{
                fontFamily:'Syne,sans-serif',
                fontSize:'14px',
                fontWeight:'700',
              }}>
                Customer Details
              </div>
              <button
                onClick={() => {
                  setSelected(null);
                  setDetail(null);
                }}
                style={{
                  background:'none',
                  border:'none',
                  color:'var(--text3)',
                  cursor:'pointer',
                  fontSize:'18px',
                }}
              >
                ✕
              </button>
            </div>

            <div style={{ padding:'20px' }}>
              <div style={{
                fontFamily:'Syne,sans-serif',
                fontSize:'17px',
                fontWeight:'700',
                marginBottom:'4px',
              }}>
                {detail.customer.company_name}
              </div>
              {detail.customer.contact_person && (
                <div style={{
                  fontSize:'13px',
                  color:'var(--text3)',
                  marginBottom:'16px',
                }}>
                  {detail.customer.contact_person}
                </div>
              )}

              {[
                ['Phone',
                  detail.customer.phone],
                ['Alt Phone',
                  detail.customer.alternate_phone
                  || '—'],
                ['Email',
                  detail.customer.email || '—'],
                ['GST',
                  detail.customer.gst_number
                  || '—'],
                ['City', detail.customer.city
                  || '—'],
                ['State',
                  detail.customer.state || '—'],
                ['Pincode',
                  detail.customer.pincode || '—'],
              ].map(([label, value]) => (
                <div key={label} style={{
                  display:'flex',
                  justifyContent:'space-between',
                  padding:'8px 0',
                  borderBottom:
                    '1px solid var(--border)',
                  fontSize:'12.5px',
                }}>
                  <span style={{
                    color:'var(--text3)',
                    fontFamily:
                      'DM Mono,monospace',
                    fontSize:'11px',
                  }}>
                    {label}
                  </span>
                  <span style={{
                    color:'var(--text)',
                    fontWeight:'500',
                  }}>
                    {value}
                  </span>
                </div>
              ))}

              {detail.customer.billing_address && (
                <div style={{
                  marginTop:'12px',
                  padding:'12px',
                  background:'var(--surface2)',
                  borderRadius:'8px',
                  fontSize:'12.5px',
                  color:'var(--text2)',
                }}>
                  <div style={{
                    fontSize:'10px',
                    fontFamily:
                      'DM Mono,monospace',
                    color:'var(--text3)',
                    marginBottom:'6px',
                    letterSpacing:'1px',
                  }}>
                    BILLING ADDRESS
                  </div>
                  {detail.customer
                    .billing_address}
                </div>
              )}

              {/* Ticket History */}
              {detail.ticket_history?.length > 0 && (
                <div style={{
                  marginTop:'16px',
                }}>
                  <div style={{
                    fontSize:'11px',
                    fontFamily:
                      'DM Mono,monospace',
                    color:'var(--text3)',
                    letterSpacing:'1px',
                    marginBottom:'8px',
                  }}>
                    RECENT TICKETS
                  </div>
                  {detail.ticket_history
                    .slice(0,5).map(t => (
                    <div key={t.id} style={{
                      display:'flex',
                      justifyContent:
                        'space-between',
                      alignItems:'center',
                      padding:'8px 0',
                      borderBottom:
                        '1px solid var(--border)',
                      fontSize:'12px',
                    }}>
                      <div>
                        <span style={{
                          color:'var(--accent)',
                          fontFamily:
                            'DM Mono,monospace',
                        }}>
                          {t.ticket_number}
                        </span>
                        <span style={{
                          color:'var(--text3)',
                          marginLeft:'8px',
                        }}>
                          {t.ticket_type}
                        </span>
                      </div>
                      <span style={{
                        fontSize:'10px',
                        padding:'2px 8px',
                        borderRadius:'10px',
                        background:
                          t.status === 'closed'
                            ? 'rgba(77,95,122,0.2)'
                          : t.status ===
                            'delivered'
                            ? 'rgba(0,229,160,0.1)'
                          : 'rgba(255,192,64,0.1)',
                        color:
                          t.status === 'closed'
                            ? 'var(--text3)'
                          : t.status ===
                            'delivered'
                            ? 'var(--green)'
                          : 'var(--yellow)',
                      }}>
                        {t.status}
                      </span>
                    </div>
                  ))}
                </div>
              )}

              {detail.customer.notes && (
                <div style={{
                  marginTop:'12px',
                  padding:'12px',
                  background:'var(--surface2)',
                  borderRadius:'8px',
                  fontSize:'12.5px',
                  color:'var(--text2)',
                }}>
                  <div style={{
                    fontSize:'10px',
                    fontFamily:
                      'DM Mono,monospace',
                    color:'var(--text3)',
                    marginBottom:'6px',
                    letterSpacing:'1px',
                  }}>
                    NOTES
                  </div>
                  {detail.customer.notes}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Customers;